import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import "react-quill/dist/quill.snow.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Col, Input, Label, Row, Spinner } from "reactstrap";
import { putUser } from "store/thunks";
import * as Yup from "yup";
import { useRole } from "components/Hooks/UserHooks";
import { ROLES_FOR_APP, isHavePermissionRole } from "helpers/role";
import { CON_WORKING_DAY_OF_WEEK, LIST_OPTION_SALARY_TYPE_USER } from "helpers/constans";
import DropdownHours from "components/Common/DropdownHours";
import DropdownOptionNew from "components/Common/DropdownOptionNew";
import DatePicker from "react-datepicker";
import ModalRegion from "components/Common/ModalRegion";
import { NumericFormat } from "react-number-format";
import { formatDateStringToKorea } from "helpers/format";

registerLocale("en", en);
registerLocale("ko", ko);

const CON_EXPERIENCE_LEVEL = [
  {
    label: "Non-Experience",
    value: 0,
  },
  {
    label: "Experienced",
    value: 1,
  },
];

const CON_WORKING_DAYS = [
  {
    label: "Specify days",
    value: 0,
  },
  {
    label: "Negotiation",
    value: 1,
  },
];

const CON_WORKING_TIME = [
  {
    label: "Specify time",
    value: 0,
  },
  {
    label: "Negotiation",
    value: 1,
  },
];

const CON_WORKING_SALARY = [
  {
    label: "Specify amount",
    value: 0,
  },
  {
    label: "Negotiation",
    value: 1,
  },
];

const WorkConditionTab = ({
  data,
  regions,
  handleUpdateSuccess,
  setLinkImage
}: {
  data?: any;
  regions?: any;
  handleUpdateSuccess?: any;
  setLinkImage?: any;
}) => {
  const { t, i18n } = useTranslation();
  const { userPermissions } = useRole();

  const [isOpenRegion, setIsOpenRegion] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleSubmit = async (values: any) => {
    try {
      setIsLoading((_prev) => true);

      const formatData = {
        ...values,
      };

      const response: any = data?.id
        ? await putUser(data?.id, {
            workingCondition: formatData,
          })
        : null;

      if (response?.data) {
        setIsLoading((_prev) => false);
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
        handleUpdateSuccess && handleUpdateSuccess();
      } else {
        setIsLoading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsLoading((_prev) => false);
      // toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      toast(t("Invalid input"), CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const validationSchema = Yup.object({
    // name: Yup.string()
    //   .trim()
    //   .required(`${t("This field is required")}`),
  });

  const formik = useFormik({
    initialValues: {
      hasExperience: true,
      isFlexibleWorkingDay: false,
      isFlexibleWorkingTime: false,
      workingDays: [1, 2, 3, 4, 5] as any,
      workingTimeFrom: "",
      workingTimeTo: "",
      startDate: null,
      isSalaryNegotiable: false,
      expectedSalaryType: "HOUR",
      expectedSalary: null,
      bio: "",
      regions: [],
      preferredTimeToContact: "",
    },
    validationSchema,
    onSubmit: handleSubmit,
  });

  const toggleDay = (dayValue: number) => {
    const currentDays = Array.isArray(formik.values.workingDays) ? formik.values.workingDays : [];

    const newDays = currentDays?.includes(dayValue)
      ? currentDays.filter((d: any) => d !== dayValue)
      : [...currentDays, dayValue];

    formik.setFieldValue("workingDays", newDays);
  };

  const togglePreferredLocation = (location: any) => {
    // if (formik.values?.regions?.includes(re)) {
    //   formik.setFieldValue("regions", [
    //     ...formik.values?.regions?.filter(
    //       (item: string) => item !== re
    //     ),
    //   ]);
    // } else {
    //   formik.setFieldValue("regions", [
    //     ...formik.values.regions,
    //     location,
    //   ]);
    // }
  };

  const handleConfirmRegion = (lstRegion: any) => {
    formik.setFieldValue("regions", lstRegion);
    setIsOpenRegion(false);
  };

  const handleCloseRegion = () => {
    setIsOpenRegion(false);
  };

  useEffect(() => {
    // console.log(data);

    if (data?.workingCondition) {
      const vFormatRegion = data?.workingCondition?.regions?.map(
        (item: any) => {
          if (item?.subRegionId && item?.regionId) {
            return {
              regionId: item?.regionId,
              subRegionId: item?.subRegionId,
              label: [item?.region?.name, item?.subRegion?.name]
                .filter(Boolean)
                ?.join(" - "),
            };
          } else {
            return {
              regionId: item?.regionId,
              label: item?.region?.name,
            };
          }
        }
      );

      formik.setValues({
        ...data?.workingCondition,
        regions: vFormatRegion || [],
        startDate: data?.workingCondition?.startDate
          ? new Date(formatDateStringToKorea(data?.workingCondition?.startDate))
          : null,
      });
    }
  }, [data]);

  useEffect(() => {
    document.title = `${t("Work Condition")} | OnnyJob`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <Row>
        <Col lg={12} className="mt-4 px-4">
          <form onSubmit={formik.handleSubmit}>
            <div
              className="d-flex flex-column mb-4 pt-3 pb-1 px-3 position-relative"
              style={{
                border: "1px dashed var(--vz-primary)",
                borderRadius: "4px",
              }}
            >
              <span
                className="text-primary position-absolute fs-13 px-1"
                style={{
                  backgroundColor: "var(--vz-secondary-bg)",
                  top: "0px",
                  transform: "translateY(-50%)",
                }}
              >
                {t("Working Conditions")}
              </span>
              <Row>
                <Col lg={12}>
                  <div className="mb-3">
                    <Label htmlFor="titleKoreaInput" className="form-label">
                      {t("Experience Level")}{" "}
                      <span className="text-danger"></span>
                    </Label>

                    <div className="d-flex justify-content-start align-items-center">
                      {CON_EXPERIENCE_LEVEL?.map((item) => {
                        return (
                          <div
                            className="d-flex justify-content-start align-items-center form-check me-3"
                            key={`experience-${String(item?.value)}`}
                            onClick={() => {
                              formik?.setFieldValue(
                                "hasExperience",
                                item.value ? true : false
                              );
                            }}
                          >
                            <input
                              className="form-check-input me-2"
                              type="radio"
                              name="experience_level"
                              id={`experience-${String(item?.value)}`}
                              value={item?.value}
                              checked={
                                item?.value ==
                                Number(formik?.values?.hasExperience)
                              }
                              style={{ minWidth: "16px" }}
                              onChange={(event) => {
                                formik?.setFieldValue(
                                  "hasExperience",
                                  item.value ? true : false
                                );
                              }}
                            />
                            <label
                              className="form-check-label position-relative"
                              htmlFor={`experience-${String(item?.value)}`}
                            >
                              {t(item?.label)}
                            </label>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </Col>

                <Col lg={12}>
                  <div className="mb-3">
                    <Label htmlFor="titleKoreaInput" className="form-label">
                      {t("Preferred Working Days")}{" "}
                      <span className="text-danger"></span>
                    </Label>

                    <div className="d-flex justify-content-start align-items-center">
                      {CON_WORKING_DAYS?.map((item) => {
                        return (
                          <div
                            key={`working-days-${String(item?.value)}`}
                            className="d-flex justify-content-start align-items-center form-check me-3"
                            onClick={() => {
                              formik?.setFieldValue(
                                "isFlexibleWorkingDay",
                                item.value ? true : false
                              );
                            }}
                          >
                            <input
                              className="form-check-input me-2"
                              type="radio"
                              name="working_days"
                              id={`work-day-${String(item?.value)}`}
                              value={item?.value}
                              checked={
                                item?.value ==
                                Number(formik?.values?.isFlexibleWorkingDay)
                              }
                              style={{ minWidth: "16px" }}
                              onChange={(event) => {
                                formik?.setFieldValue(
                                  "isFlexibleWorkingDay",
                                  item.value ? true : false
                                );
                              }}
                            />
                            <label
                              className="form-check-label position-relative"
                              htmlFor={`work-day-${String(item?.value)}`}
                            >
                              {t(item?.label)}
                            </label>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </Col>

                {!formik?.values?.isFlexibleWorkingDay && (
                  <Col lg={12}>
                    <div className="d-flex gap-2 mb-3">
                      {CON_WORKING_DAY_OF_WEEK.map((day) => (
                        <button
                          key={day.value}
                          type="button"
                          onClick={() => toggleDay(day.value)}
                          style={{ border: "unset" }}
                          className={`px-4 py-2 rounded-md ${
                            Array?.isArray(formik.values?.workingDays) && formik.values?.workingDays?.includes(day?.value)
                              ? "bg-primary text-white"
                              : "text-gray-300"
                          }`}
                        >
                          {t(day.label)}
                        </button>
                      ))}
                    </div>
                  </Col>
                )}  

                <Col lg={12}>
                  <div className="mb-3">
                    <Label htmlFor="titleKoreaInput" className="form-label">
                      {t("Preferred Working Time")}{" "}
                      <span className="text-danger"></span>
                    </Label>

                    <div className="d-flex justify-content-start align-items-center">
                      {CON_WORKING_TIME?.map((item) => {
                        return (
                          <div
                            key={`working-times-${String(item?.value)}`}
                            className="d-flex justify-content-start align-items-center form-check me-3"
                            onClick={() => {
                              formik?.setFieldValue(
                                "isFlexibleWorkingTime",
                                item.value ? true : false
                              );
                            }}
                          >
                            <input
                              className="form-check-input me-2"
                              type="radio"
                              name="working_time"
                              id={`work-time-${String(item?.value)}`}
                              value={item?.value}
                              checked={
                                item?.value ==
                                Number(formik?.values?.isFlexibleWorkingTime)
                              }
                              style={{ minWidth: "16px" }}
                              onChange={(event) => {
                                formik?.setFieldValue(
                                  "isFlexibleWorkingTime",
                                  item.value ? true : false
                                );
                              }}
                            />
                            <label
                              className="form-check-label position-relative"
                              htmlFor={`work-time-${String(item?.value)}`}
                            >
                              {t(item?.label)}
                            </label>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </Col>

                {!formik?.values?.isFlexibleWorkingTime && (
                  <Col lg={12} className="date-picker-wrapper-custom">
                    <Row className="mb-3 d-flex align-items-center">
                      <Col lg={4} style={{ maxWidth: "160px" }}>
                        <DropdownHours
                          name="startTime"
                          initialValue={formik?.values?.workingTimeFrom || ""}
                          onChangeSelect={(value: any) => {
                            formik.setFieldValue(
                              `workingTimeFrom`,
                              value?.value
                            );
                          }}
                        />
                      </Col>
                      <Col
                        lg={2}
                        style={{
                          paddingLeft: "0",
                          paddingRight: "0",
                          textAlign: "center",
                          maxWidth: "2px",
                        }}
                      >
                        <span>-</span>
                      </Col>
                      <Col lg={4} style={{ maxWidth: "160px" }}>
                        <DropdownHours
                          name="endTime"
                          initialValue={formik?.values?.workingTimeTo}
                          onChangeSelect={(value: any) => {
                            formik.setFieldValue(`workingTimeTo`, value?.value);
                          }}
                        />
                      </Col>
                    </Row>
                  </Col>
                )}

                <Col md={6} lg={4}>
                  <div className="mb-3">
                    <Label htmlFor="work_period" className="form-label">
                      {t("Preferred Start Date")}
                    </Label>
                    <div className="w-100">
                      <DatePicker
                        name={"startDate"}
                        className="form-control"
                        selected={formik?.values?.startDate}
                        placeholderText={t("Start Date")}
                        onChange={(date: any) => {
                          formik.setFieldValue("startDate", date);
                        }}
                        dateFormat="yyyy-MM-dd"
                        isClearable={true}
                      />
                    </div>
                    {formik.touched.startDate && formik.errors.startDate ? (
                      <div className="text-danger mt-2">
                        {formik.errors.startDate}
                      </div>
                    ) : null}
                  </div>
                </Col>

                <Col lg={12}>
                  <div className="mb-3">
                    <Label htmlFor="salary" className="form-label">
                      {t("Salary")} <span className="text-danger"></span>
                    </Label>

                    <div className="d-flex justify-content-start align-items-center">
                      {CON_WORKING_SALARY?.map((item) => {
                        return (
                          <div
                            key={`salarys-${String(item?.value)}`}
                            className="d-flex justify-content-start align-items-center form-check me-3"
                            onClick={() => {
                              formik?.setFieldValue(
                                "isSalaryNegotiable",
                                item.value ? true : false
                              );
                            }}
                          >
                            <input
                              className="form-check-input me-2"
                              type="radio"
                              name="working_salary"
                              id={`salary-${String(item?.value)}`}
                              value={item?.value}
                              checked={
                                item?.value ==
                                Number(formik?.values?.isSalaryNegotiable)
                              }
                              style={{ minWidth: "16px" }}
                              onChange={(event) => {
                                formik?.setFieldValue(
                                  "isSalaryNegotiable",
                                  item.value ? true : false
                                );
                              }}
                            />
                            <label
                              className="form-check-label position-relative"
                              htmlFor={`salary-${String(item?.value)}`}
                            >
                              {t(item?.label)}
                            </label>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </Col>

                {!formik?.values?.isSalaryNegotiable && (
                  <>
                    <Col md={3} lg={3}>
                      <div className="mb-3">
                        <Label htmlFor="contact_name" className="form-label">
                          {t("Salary Type")}
                        </Label>
                        <DropdownOptionNew
                          name="expectedSalaryType"
                          dataList={LIST_OPTION_SALARY_TYPE_USER || []}
                          placeholder={`${t("Salary Type")}...`}
                          className="dropdown-status-rounded"
                          classNamePrefix="name-prefix"
                          initialValue={formik?.values?.expectedSalaryType}
                          onChangeSelect={(e: any) =>
                            formik.setFieldValue("expectedSalaryType", e?.value)
                          }
                          isHasOptionAll={false}
                        />
                        {formik.touched.expectedSalaryType &&
                        formik.errors.expectedSalaryType ? (
                          <div className="text-danger mt-2">
                            {formik.errors.expectedSalaryType}
                          </div>
                        ) : null}
                      </div>
                    </Col>

                    <Col md={6} lg={6}>
                      <div className="mb-3">
                        <Label htmlFor="expectedSalary" className="form-label">
                          {t("Amount")}
                          <span className="text-danger"> *</span>
                        </Label>

                        <div className="d-flex mb-2 gap-2 align-items-center">
                          <NumericFormat
                            className="form-control"
                            value={formik?.values?.expectedSalary}
                            placeholder={t("Amount")}
                            allowLeadingZeros
                            thousandSeparator=","
                            isAllowed={(values) => {
                              const { formattedValue, floatValue } = values;
                              return formattedValue === "" || (floatValue || 0) <= 9999999999;
                            }}
                            onValueChange={(values: any) => {
                              const { floatValue } = values;
                              formik.setFieldValue(
                                "expectedSalary",
                                floatValue
                              );
                            }}
                          />
                          <div>₩</div>
                        </div>

                        {formik.touched.expectedSalary &&
                        formik.errors.expectedSalary ? (
                          <div className="text-danger mt-2">
                            {formik.errors.expectedSalary}
                          </div>
                        ) : null}
                      </div>
                    </Col>
                  </>
                )}

                <Col lg={12}>
                  <div className="mb-3">
                    <Label htmlFor="bio" className="form-label">
                      {t("Self Introduce")}
                      <span className="text-danger"> *</span>
                    </Label>

                    <div className="d-flex mb-2 gap-2">
                      <textarea
                        className="form-control"
                        name={`bio`}
                        maxLength={300}
                        value={formik?.values?.bio}
                        placeholder={`${t(
                          "Please enter a brief self-introduction."
                        )}`}
                        onChange={(event) => {
                          formik.setFieldValue(`bio`, event?.target?.value);
                        }}
                        style={{ height: 80 }}
                      />
                    </div>

                    {formik.touched.bio && formik.errors.bio ? (
                      <div className="text-danger mt-2">
                        {formik.errors.bio}
                      </div>
                    ) : null}
                  </div>
                </Col>

                <Col lg={12}>
                  <div className="mb-3">
                    <Label htmlFor="description" className="form-label">
                      {t("Preferred Work Location")}
                    </Label>
                    <div className="d-flex gap-2 mb-3 flex-wrap">
                      {formik?.values?.regions?.map(
                        (location: any, index: any) => (
                          <button
                            key={index}
                            type="button" // Ensure button doesn't trigger form submission
                            onClick={() => togglePreferredLocation(location)}
                            style={{ border: "unset" }}
                            className={`px-4 py-2 rounded-md bg-primary text-white`}
                            // className={`px-4 py-2 rounded-md ${
                            //   formik.values.regions.includes(location)
                            //     ? "bg-primary text-white"
                            //     : "text-gray-300"
                            // }`}
                          >
                            {location?.label}
                          </button>
                        )
                      )}
                      <button
                        type="button" // Ensure button doesn't trigger form submission
                        onClick={() => setIsOpenRegion(true)}
                        style={{ border: "unset" }}
                        className={`px-4 py-2 rounded-md text-gray-300`}
                      >
                        {t("Select Region")}
                      </button>
                    </div>
                  </div>
                </Col>

                <Col md={6} lg={4}>
                  <div className="mb-3">
                    <Label htmlFor="work_period" className="form-label">
                      {t("Preferred Contact Time (Optional)")}
                    </Label>
                    <div className="w-100">
                      <Input
                        name="workplace"
                        type="text"
                        className="form-control"
                        id="workplace"
                        placeholder={t("Workplace")}
                        value={formik?.values?.preferredTimeToContact || ""}
                        onChange={(event: any) =>
                          formik.setFieldValue(
                            "preferredTimeToContact",
                            event?.target?.value
                          )
                        }
                      />
                    </div>
                    {formik.touched.preferredTimeToContact &&
                    formik.errors.preferredTimeToContact ? (
                      <div className="text-danger mt-2">
                        {formik.errors.preferredTimeToContact}
                      </div>
                    ) : null}
                  </div>
                </Col>
              </Row>
            </div>

            <Row className="mb-3 mt-2">
              <Col lg={12}>
                <div className="hstack gap-2 justify-content-end">
                  {isHavePermissionRole(
                    ROLES_FOR_APP.USER_UPDATE,
                    userPermissions
                  ) && (
                    <button type="submit" className="btn btn-primary fs-14">
                      {isLoading && (
                        <Spinner size="sm" className="me-2"></Spinner>
                      )}
                      {t("Button Save")}
                    </button>
                  )}
                </div>
              </Col>
            </Row>
          </form>
        </Col>

        {isOpenRegion && (
          <ModalRegion
            regions={regions}
            onConfirm={handleConfirmRegion}
            onClose={handleCloseRegion}
            lstRegionSelected={formik?.values?.regions}
          />
        )}
      </Row>
    </React.Fragment>
  );
};

export default WorkConditionTab;
